import { render } from "./TasksStatus.vue?vue&type=template&id=0c4de47d"
import script from "./TasksStatus.vue?vue&type=script&lang=js"
export * from "./TasksStatus.vue?vue&type=script&lang=js"

import "./TasksStatus.vue?vue&type=style&index=0&id=0c4de47d&lang=sass"

import exportComponent from "C:\\Riman\\Web\\Alex\\ars\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__